import { FeatureAppLoader } from '@feature-hub/react';
import React from 'react';
import { PortalContext } from '../../context/PortalContext';
import type { FeatureAppConfiguration } from '@volkswagen-onehub/featureapp-service';

export const LoaderSac: React.FC<{}> = () => {
	const { featureAppService } = React.useContext(PortalContext);
	const oneformSac = featureAppService.featureAppConfigurations['es-oneform-sac'] as FeatureAppConfiguration | undefined;

	return (
		<>
			{oneformSac && (
				<FeatureAppLoader
					{...oneformSac}
					featureAppId={`${oneformSac.name}:oneform`}
					done={() => {}}
					beforeCreate={(env) => {
						const featureServices = env.featureServices as Record<string, any>;
						if (featureServices['fa-content-service']) {
							featureServices['fa-content-service'].content = {
								triggerCase: 'Generico',
								headline: 'Si necesitas ayuda, serás el primero de nuestra lista',
								bodycopy:
									'Literalmente. Llámanos al 800 500 100 para recibir atención prioritaria o rellena el formulario y te contactaremos por email. <br>También estamos disponibles por chat haciendo clic en el botón de la esquina izquierda.</br>',
								cta: 'Contáctanos por email',
							};
						}
						if (featureServices['api-key-provider']) {
							featureServices['api-key-provider'].apiKey = oneformSac.apiKey;
						}
					}}
				/>
			)}
		</>
	);
};
